import { render } from "./PropertyEvent.vue?vue&type=template&id=ba807622"
import script from "./PropertyEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyEvent.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/property/PropertyEvent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba807622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba807622', __exports__)) {
    console.log('reload')
    api.reload('ba807622', __exports__)
  }
  
  module.hot.accept("./PropertyEvent.vue?vue&type=template&id=ba807622", () => {
    console.log('re-render')
    api.rerender('ba807622', render)
  })

}


export default __exports__